module.exports = __webpack_public_path__ + "img/expert.3c7e7351.png";